import { crypto_images } from "@/components/crypto_images";
import Image from "next/image";

const BalanceItem = ({
    img,
    fullName,
    shortName,
    amount,
    amountUSD,
    type,
}: {
    img: string;
    fullName: string;
    shortName: string;
    amount: number;
    amountUSD: number;
    type: "crypto" | "currency";
}) => {
    const imageSrc = crypto_images[img] || crypto_images['generic'];
    return (
        <div className="flex p-2  w-full justify-between  items-center gap-2">
            <div className="flex gap-2 items-center flex-1 ">
                {" "}
                <Image width={30} height={30} alt="" src={imageSrc} />
                <div className="flex flex-col">
                    <span>{fullName}</span>
                    <span className="text-xs text-gray-500 font-semibold">
                        {shortName}
                    </span>
                </div>{" "}
            </div>
            <div className="flex flex-col text-right">
                <span className="text-sm">
                    {type === "crypto"
                        ? parseFloat(amount.toFixed(8)).toString().replace(".", ",")
                        : amount.toLocaleString()}
                </span>
                <span className="text-xs text-teal-500">
                    $ {amountUSD?.toLocaleString()}
                </span>
            </div>
        </div>
    );
};

export default BalanceItem;